@if (report) {
<div class="drd-wrapper">

    <!-- ── Navigation bar ── -->
    <div class="drd-navbar">
        <div class="drd-navbar-tabs">
            <button class="drd-navbar-tab drd-navbar-tab--pending"
                [class.drd-navbar-tab--active]="activeTab === 'PENDING'"
                (click)="onTabChange('PENDING')">Pending</button>
            <button class="drd-navbar-tab drd-navbar-tab--acknowledged"
                [class.drd-navbar-tab--active]="activeTab === 'ACKNOWLEDGED'"
                (click)="onTabChange('ACKNOWLEDGED')">Acknowledged</button>
            <button class="drd-navbar-tab drd-navbar-tab--rejected"
                [class.drd-navbar-tab--active]="activeTab === 'REJECTED'"
                (click)="onTabChange('REJECTED')">Rejected</button>
        </div>
        <div class="drd-navbar-nav">
            <button type="button" class="drd-nav-btn" (click)="onPrev()" [disabled]="!hasPrev">‹ Prev</button>
            <span class="drd-nav-count">{{ currentIndex + 1 }} of {{ total }}</span>
            <button type="button" class="drd-nav-btn" (click)="onNext()" [disabled]="!hasNext">Next ›</button>
        </div>
    </div>

    <!-- ── Body ── -->
    <div class="drd-body mb-3">

        <!-- LEFT: photos -->
        <div class="drd-left">
            <div class="drd-left-header">
                <span class="drd-left-title">Damage Photos</span>
                <span class="drd-status-badge" [ngClass]="statusClass">{{ report.status }}</span>
                <span class="drd-report-ref">#{{ report.id }}</span>
            </div>

            @if (photos.length > 0) {
            <div class="drd-photo-grid">
                @for (url of photos; track $index) {
                <div class="drd-photo-cell" (click)="openLightbox($index)"
                    (keyup.enter)="openLightbox($index)" tabindex="0" role="button">
                    <img [src]="url" [alt]="'Photo ' + ($index + 1)" class="drd-photo-img" />
                    <span class="drd-photo-label">Photo {{ $index + 1 }}</span>
                </div>
                }
            </div>
            } @else {
            <div class="drd-no-photos">
                <span>📷</span>
                <span>No photos available</span>
            </div>
            }

            <!-- Actions -->
            @if (isPending) {
            <div class="drd-actions">
                <button type="button" class="drd-btn drd-btn--reject" (click)="onReject()">✕  Reject</button>
                <button type="button" class="drd-btn drd-btn--acknowledge" (click)="onAcknowledge()">✔  Acknowledge</button>
            </div>
            }
        </div>

        <!-- RIGHT: info -->
        <div class="drd-right">

            <!-- Report info -->
            <div class="drd-card">
                <h4 class="drd-card-title">Report</h4>
                <div class="drd-grid">
                    <div class="drd-field">
                        <span class="drd-label">REPORT ID</span>
                        <span class="drd-value">#{{ report.id }}</span>
                    </div>
                    <div class="drd-field">
                        <span class="drd-label">REPORT TYPE</span>
                        <span class="drd-value">{{ report.reportType | titlecase }}</span>
                    </div>
                    <div class="drd-field">
                        <span class="drd-label">DAMAGE TYPE</span>
                        <span class="drd-value">{{ report.damageTypes.join(', ') | titlecase }}</span>
                    </div>
                    <div class="drd-field">
                        <span class="drd-label">CREATED AT</span>
                        <span class="drd-value">{{ report.createdAt | date:'dd/MM/yyyy hh:mm a' }}</span>
                    </div>
                    @if (report.reviewedAt) {
                    <div class="drd-field drd-field--full">
                        <span class="drd-label">REVIEWED AT</span>
                        <span class="drd-value">{{ report.reviewedAt | date:'dd/MM/yyyy hh:mm a' }}</span>
                    </div>
                    }
                    @if (report.description) {
                    <div class="drd-field drd-field--full">
                        <span class="drd-label">DESCRIPTION</span>
                        <span class="drd-value">{{ report.description }}</span>
                    </div>
                    }
                    @if (report.rejectionReason) {
                    <div class="drd-field drd-field--full">
                        <span class="drd-label">REJECTION REASON</span>
                        <span class="drd-value">{{ report.rejectionReason }}</span>
                    </div>
                    }
                </div>
            </div>

            <!-- Customer -->
            <div class="drd-card">
                <div class="drd-card-title-row">
                    <h4 class="drd-card-title">Customer</h4>
                    @if (customerDetails()) {
                    <span class="drd-cust-status">
                        <span class="drd-cust-status-dot"></span>
                        {{ customerDetails()!.status }}
                    </span>
                    }
                </div>
                <div class="drd-customer-row">
                    <div class="drd-avatar">{{ customerInitials }}</div>
                    <div class="drd-customer-meta">
                        <span class="drd-customer-name">{{ report.customerFirstName }} {{ report.customerLastName }}</span>
                        @if (customerDetails()) {
                        <span class="drd-customer-sub">
                            {{ customerDetails()!.totalRides }} rides
                            @if (customerDetails()!.averageFeedbackRating !== null && customerDetails()!.averageFeedbackRating !== undefined) {
                            · ★ {{ customerDetails()!.averageFeedbackRating | number:'1.1-1' }}
                            }
                            · {{ customerDetails()!.deviceType }}
                        </span>
                        }
                    </div>
                </div>
                <div class="drd-grid mt-10">
                    <div class="drd-field drd-field--full">
                        <span class="drd-label">EMAIL</span>
                        <span class="drd-value">{{ report.customerEmail }}</span>
                    </div>
                    @if (customerDetails()?.phoneNumber) {
                    <div class="drd-field drd-field--full">
                        <span class="drd-label">PHONE</span>
                        <span class="drd-value">{{ customerDetails()!.phoneNumber }}</span>
                    </div>
                    }
                </div>
            </div>

            <!-- Car -->
            <div class="drd-card">
                <h4 class="drd-card-title">Car</h4>
                <div class="drd-car-row">
                    <div class="drd-car-thumb">
                        @if (carDetails()?.imageUrl) {
                        <img [src]="carDetails()!.imageUrl" [alt]="report.plateNo" class="drd-car-thumb-img" />
                        } @else {
                        <span class="drd-car-thumb-placeholder">🚗</span>
                        }
                    </div>
                    <div class="drd-car-meta">
                        <span class="drd-car-plate">{{ report.plateNo }}</span>
                        @if (carDetails()?.model) {
                        <span class="drd-car-model">{{ carDetails()!.model.maker }} {{ carDetails()!.model.name }} · {{ carDetails()!.model.bodyType | titlecase }}</span>
                        }
                    </div>
                </div>
                @if (carDetails()) {
                <div class="drd-grid mt-10">
                    <div class="drd-field">
                        <span class="drd-label">FUEL LEVEL</span>
                        <span class="drd-value">{{ carDetails()!.telemetry.fuelLevel  }}</span>
                    </div>
                    <div class="drd-field">
                        <span class="drd-label">ENGINE</span>
                        <span class="drd-value">{{ carDetails()!.telemetry.engineStatus }}</span>
                    </div>
                </div>
                }
            </div>

        </div>
    </div>
</div>
}

<!-- ── Lightbox ── -->
@if (lightboxOpen && photos[lightboxIndex]) {
<div class="drd-lightbox-backdrop" (click)="lightboxOpen = false"
    (keyup.escape)="lightboxOpen = false" tabindex="0" role="dialog" aria-modal="true">
    <div class="drd-lightbox" (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()" tabindex="-1">
        <div class="drd-lightbox-header">
            <span class="drd-lightbox-title">Report #{{ report.id }} — Photo {{ lightboxIndex + 1 }} of {{ photos.length }}</span>
            <button type="button" class="drd-lightbox-close" (click)="lightboxOpen = false">✕</button>
        </div>
        <div class="drd-lightbox-body">
            <button type="button" class="drd-lightbox-nav drd-lightbox-nav--prev" (click)="lightboxPrev()" [disabled]="lightboxIndex === 0">&#8249;</button>
            <img [src]="photos[lightboxIndex]" alt="Damage photo" class="drd-lightbox-img" />
            <button type="button" class="drd-lightbox-nav drd-lightbox-nav--next" (click)="lightboxNext()" [disabled]="lightboxIndex === photos.length - 1">&#8250;</button>
        </div>
    </div>
</div>
}
